import { DataGridColSettings } from '@/components/DataGrid/utils';

export const unitDataGridCols: DataGridColSettings[] = [
  {
    field: 'name',
    headerName: 'Unit name',
    visible: true,
  },
  {
    field: 'type',
    headerName: 'Unit type',
    width: 340,
    visible: true,
  },
  {
    field: 'status',
    headerName: 'Unit status',
    width: 340,
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    width: 100,
    visible: true,
  },
];
type IUnitManagementTab = {
  path: string;
  label: string;
};

export const UnitManagementTabs: Record<string, IUnitManagementTab> = {
  units: {
    path: 'units',
    label: 'Units',
  },
  types: {
    path: 'types',
    label: 'Types',
  },
  assignments: {
    path: 'assignments',
    label: 'Assignments',
  },
  history: {
    path: 'history',
    label: 'Shift History',
  },
};

export const UnitFormFields = {
  title: 'Unit information',
  items: [
    {
      name: 'name',
      type: 'text',
      label: 'Unit name',
      rules: {
        required: 'This field is required.',
        minLength: {
          value: 3,
          message: 'Name should be more than 3 characters long.',
        },
      },
    },
    {
      name: 'type',
      type: 'autocomplete',
      label: 'Unit type',
      rules: {
        required: 'This field is required.',
      },
    },
  ],
};

export const StandByCheckBox = {
  name: 'isStandByWhenOffDuty',
  type: 'checkbox',
  label: 'Standby when off duty',
};

export const UnitDefaultValues = {
  name: '',
  type: '',
  isStandByWhenOffDuty: false,
};
